<template>
    <charges-acknowledgement-update
        :charge="charge.uuid"
        @success="show_edit_modal = false; show_updated_modal = true"
    >
        <div
            slot-scope="{
                sid,
                is_loading: is_saving,
                error,
                update,
                forget
            }"
        >
            <error-modal
                v-if="error && $error.is(error, { exclude: [422] })"
                :error="error"
                @close="forget"
            />

            <modal-success
                v-else-if="show_updated_modal"
                :is-open="show_updated_modal"
                @close="closeAll(); $emit('success')"
            >
                <template slot="heading">Charge acknowledged</template>

                <p>Thanks for acknowledging this offline payment. We have notified your tenant.</p>

                <div
                    slot="footer"
                    slot-scope="{ close }"
                    class="flex flex-col md:flex-row-reverse"
                >
                    <button
                        type="button"
                        @click.prevent="close"
                        class="btn text-center"
                    >
                        Close
                    </button>
                </div>
            </modal-success>

            <modal-blue
                v-else-if="show_edit_modal"
                :is-open="show_edit_modal"
                @close="closeAll"
            >
                <base-form
                    slot-scope="{ close }"
                    @submit="update(form)"
                >
                    <div class="border-b px-4 pt-6 sm:px-6">
                        <h6 class="text-center font-semibold text-lg font-normal mb-3">
                            Acknowledge Offline Payment
                        </h6>

                        <div class="text-grey-darker mb-6">
                            <p class="mb-3">When a tenant makes an offline payment, it is marked as 'requested' until you acknowledge it.</p>

                            <p class="mb-3">You should have received this payment by some means other than Rentora (e.g. cash or bank transfer).</p>

                            <form-item
                                :sid="sid"
                                name="state"
                            >
                                <input-select
                                    v-model="form.state"
                                    :sid="sid"
                                    :disabled="is_saving"
                                    :options="[
                                        { value: 'succeeded', label: 'I have received this payment' },
                                        { value: 'failed', label: 'I have not received this payment' }
                                    ]"
                                    name="state"
                                />
                            </form-item>
                        </div>
                    </div>

                    <footer class="flex flex-col md:flex-row-reverse bg-grey-bg rounded-b py-3 px-6">
                        <base-button
                            :is-loading="is_saving"
                            type="submit"
                            class="btn btn-blue w-full md:w-auto mb-3 md:mb-0 md:ml-3"
                        >
                            Acknowledge
                        </base-button>

                        <button
                            type="button"
                            class="btn text-center"
                            @click.prevent="close"
                        >
                            Cancel
                        </button>
                    </footer>
                </base-form>
            </modal-blue>
        </div>
    </charges-acknowledgement-update>
</template>

<script>
    import ChargesAcknowledgementUpdate from '../../../../../components/charges-acknowledgement-update'

    export default {
        components: {
            ChargesAcknowledgementUpdate
        },
        model: {
            prop: 'toggled',
            event: 'toggle'
        },
        props: {
            toggled: {
                type: Boolean,
                required: true
            },
            charge: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                show_edit_modal: this.toggled,
                show_updated_modal: false,
                form: {
                    state: 'succeeded'
                }
            }
        },
        watch: {
            toggled () {
                this.show_edit_modal = this.toggled
            }
        },
        methods: {
            closeAll () {
                this.show_updated_modal = false
                this.show_edit_modal = false

                this.$emit('toggle', false)
            },
            onSuccess () {
                this.show_edit_modal = false
                this.show_updated_modal = true
            }
        }
    }
</script>
